import { TFunction } from 'i18next';

import { UserCompetency } from '../types';

// Review request statuses
export const getReviewStatusColor = (status: string): string => {
  switch (status) {
    case 'pending':
      return 'yellow';
    case 'approved':
      return 'teal';
    case 'rejected':
      return 'red';
    default:
      return 'gray';
  }
};

export const getReviewStatusText = (status: string, t: TFunction): string => {
  switch (status) {
    case 'pending':
      return t('reviewRequests.statusMap.pending');
    case 'approved':
      return t('reviewRequests.statusMap.approved');
    case 'rejected':
      return t('reviewRequests.statusMap.rejected');
    default:
      return status;
  }
};

export const getReviewStatusConfig = (
  status: string,
  t: TFunction,
): { color: string; text: string } => ({
  color: getReviewStatusColor(status),
  text: getReviewStatusText(status, t),
});

// Goal statuses. Одна шкала для карточки, фильтра и плана: просрочка — отдельный
// статус, а не бейдж поверх «Ожидает» или «В работе».
export type GoalState = 'pending' | 'active' | 'overdue' | 'completed';

export const getGoalState = (goal: { status: string; isOverdue?: boolean }): GoalState => {
  if (goal.status === 'completed') return 'completed';
  if (goal.isOverdue) return 'overdue';
  return goal.status === 'accepted' ? 'active' : 'pending';
};

const GOAL_STATE_COLOR: Record<GoalState, string> = {
  pending: 'yellow',
  active: 'blue',
  overdue: 'red',
  completed: 'teal',
};

export const getGoalStatusColor = (goal: { status: string; isOverdue?: boolean }): string =>
  GOAL_STATE_COLOR[getGoalState(goal)];

export const getGoalStatusText = (
  goal: { status: string; isOverdue?: boolean },
  t: TFunction,
): string => t(`goals.status.${getGoalState(goal)}`);

// Active/inactive status (teams, users)
export const getActiveStatusColor = (status: string): string => {
  return status === 'active' ? 'teal' : 'gray';
};

export const getCompetencyStatusColor = (
  competencyId: string,
  userCompetencies: UserCompetency[],
): string => {
  return userCompetencies.some((uc) => uc.competencyId === competencyId) ? 'teal' : 'gray';
};
